import React from "react";
import app, { getAllDocsSnap, setDocData } from "../../Firebase/Firebase.utils";
import { useEffect, useState } from "react";
import { Select } from "@mui/material";
import InputBoxSelect from "../../components/InputBoxSelect";
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";
import {
  FaBuilding,
  FaCalendarAlt,
  FaMoneyBillWave,
  FaUser,
  FaCheckCircle,
  FaClock,
} from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";

function FinanceApproval() {
  const [financeApproval, setFinanceApproval] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredList, setFilteredList] = useState([]);
  const [activePill, setActivePill] = useState("all");
  const [originalList, setOriginalList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAllBillings = async () => {
      const res = await getAllDocsSnap("billing", (data) => {
        //arrange by date approved
        data.sort((a, b) => {
          return (
            new Date(b.created_at.toDate()) - new Date(a.created_at.toDate())
          );
        });

        //filter only approved status
        const approved = data.filter((item) => item.status === "approved");
        setFinanceApproval(approved);
        setOriginalList(data);
        setFilteredList(data);
        setLoading(true);
      });
    };
    fetchAllBillings();
  }, []);

  const pillStyle =
    "px-4 py-1 rounded-full text-xs border border-leechiuOrange";
  const activePillStyle =
    "bg-orange-500 rounded-full border px-4 py-1 text-white text-xs";

  const handleFilterPill = (status) => {
    setActivePill(status);
    let filtered = originalList;

    // Apply status filter
    if (status === "all pending") {
      filtered = financeApproval.filter(
        (item) =>
          item.finance_status === null ||
          item.finance_status === "" ||
          item.finance_status === undefined ||
          item.finance_status === "for fixing" ||
          item.finance_status === "finance checking"
      );
    } else if (status !== "all") {
      filtered = financeApproval.filter(
        (item) => item.finance_status === status
      );
    }

    // Apply search filter
    if (searchQuery) {
      filtered = filtered.filter((item) =>
        item.client_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setFilteredList(filtered);
  };

  // Add search handler
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    let filtered = originalList;

    // Apply status filter
    if (activePill === "all pending") {
      filtered = financeApproval.filter(
        (item) =>
          item.finance_status === null ||
          item.finance_status === "" ||
          item.finance_status === undefined ||
          item.finance_status === "for fixing" ||
          item.finance_status === "finance checking"
      );
    } else if (activePill !== "all") {
      filtered = financeApproval.filter(
        (item) => item.finance_status === activePill
      );
    }

    // Apply search filter
    if (query) {
      filtered = filtered.filter((item) =>
        item.client_name.toLowerCase().includes(query.toLowerCase())
      );
    }

    setFilteredList(filtered);
  };

  const financeOptions = [
    { value: "preparing billing", label: "preparing billing" },
    { value: "bill prepared", label: "bill prepared" },
    { value: "billing sent", label: "billing sent" },
    { value: "collected", label: "collected" },
  ];

  const handleUpdateStatus = (e) => {};

  const handleSelectStatus = (item, e) => {
    const updateBillStatus = async () => {
      const res = await setDocData("billing", item.id, {
        financeStatus: e.value,
      });
    };
    updateBillStatus();
    setActivePill("approved");
  };

  const handleNavigate = (id) => {
    navigate(`/financeView/${id}`);
  };

  return (
    <div>
      <div className="mb-8 font-bold">Billing List with Status</div>

      {/* Add search bar */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search by client name..."
          value={searchQuery}
          onChange={handleSearch}
          className="w-full md:w-96 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
        />
      </div>

      <div className="flex items-center gap-2">
        <button
          className={activePill === "all" ? activePillStyle : pillStyle}
          onClick={() => handleFilterPill("all")}
        >
          All
        </button>
        <button
          onClick={() => handleFilterPill("all pending")}
          className={activePill === "all pending" ? activePillStyle : pillStyle}
        >
          Finance Pending
        </button>
        <button
          onClick={() => handleFilterPill("billing preparation")}
          className={
            activePill === "billing preparation" ? activePillStyle : pillStyle
          }
        >
          Bill Preparing
        </button>
        <button
          onClick={() => handleFilterPill("billing ready")}
          className={
            activePill === "billing ready" ? activePillStyle : pillStyle
          }
        >
          Bill Ready
        </button>

        <button
          onClick={() => handleFilterPill("billing sent")}
          className={
            activePill === "billing sent" ? activePillStyle : pillStyle
          }
        >
          Bill Sent
        </button>

        <button
          onClick={() => handleFilterPill("collected")}
          className={activePill === "collected" ? activePillStyle : pillStyle}
        >
          Collected
        </button>
      </div>

      <div>
        {filteredList.map((item) => (
          <div
            key={item.id}
            className="mt-4 bg-white p-6 rounded-xl shadow-lg 
            hover:cursor-pointer hover:shadow-xl transition duration-300 ease-in-out hover:bg-gray-50
            border border-gray-100"
            onClick={() => handleNavigate(item.id)}
          >
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="p-3 bg-[#002368]/5 rounded-lg">
                  <FaBuilding className="text-[#002368] text-xl" />
                </div>
                <div>
                  <div className="text-lg font-semibold text-gray-800">
                    {item.client_name}
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                    <FaCalendarAlt className="text-[#ff5003]" />
                    {item.created_at.toDate().toLocaleString()}
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-3">
                <div
                  className={`px-3 py-1.5 rounded-full text-sm font-medium ${
                    item.billing_type === "lease"
                      ? "bg-[#002368]/10 text-[#002368]"
                      : "bg-[#ff5003]/10 text-[#ff5003]"
                  }`}
                >
                  {item.billing_type}
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <FaMoneyBillWave className="text-[#ff5003]" />
                  <span className="font-medium">
                    Php {parseFloat(item.amount).toLocaleString()}
                  </span>
                </div>
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-gray-100">
              <div className="flex flex-wrap items-center gap-4 text-sm">
                <div className="flex items-center gap-2">
                  {item.status === "approved" ? (
                    <FaCheckCircle className="text-green-500" />
                  ) : (
                    <FaClock className="text-yellow-500" />
                  )}
                  <span className="text-gray-600">
                    Approver Status:{" "}
                    <span className="font-medium">{item.status}</span>
                  </span>
                </div>

                <div className="flex items-center gap-2">
                  {item.finance_status ? (
                    <FaCheckCircle className="text-green-500" />
                  ) : (
                    <MdOutlinePendingActions className="text-yellow-500" />
                  )}
                  <span className="text-gray-600">
                    Finance Status:{" "}
                    <span className="font-medium">
                      {item.finance_status || "Pending"}
                    </span>
                  </span>
                </div>

                <div className="flex items-center gap-2">
                  <FaUser className="text-[#002368]" />
                  <span className="text-gray-600">
                    Requested by:{" "}
                    <span className="font-medium">{item.created_by}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FinanceApproval;
